!(function (e) {
  e.fn.sameHeight = function (n) {
    var h = e.extend(
      {
        skipClass: 'same-height-ignore',
        leftEdgeClass: 'same-height-left',
        rightEdgeClass: 'same-height-right',
        elements: '>*',
        flexible: !1,
        multiLine: !1,
        useMinHeight: !1,
        biggestHeight: !1,
      },
      n,
    );
    return this.each(function () {
      var n,
        o,
        a = e(this),
        r = a.find(h.elements).not('.' + h.skipClass);
      if (r.length) {
        f();
        var g = function () {
          o ||
            ((o = !0),
            f(),
            clearTimeout(n),
            (n = setTimeout(function () {
              f(),
                setTimeout(function () {
                  o = !1;
                }, 10);
            }, 100)));
        };
        h.flexible && e(window).bind('resize orientationchange fontresize', g), e(window).bind('load', g);
      }
      function f() {
        r.css(h.useMinHeight && t ? 'minHeight' : 'height', ''),
          h.multiLine
            ? (function (n, h) {
                var o,
                  a = e(),
                  r = 0,
                  g = n.eq(0).offset().top;
                n.each(function (t) {
                  var n = e(this);
                  n.offset().top === g
                    ? (a = a.add(this))
                    : ((o = i(a)), (r = Math.max(r, s(a, o, h))), (a = n), (g = n.offset().top));
                }),
                  a.length && ((o = i(a)), (r = Math.max(r, s(a, o, h))));
                h.biggestHeight && n.css(h.useMinHeight && t ? 'minHeight' : 'height', r);
              })(r, h)
            : s(r, a, h);
      }
    });
  };
  var t = void 0 !== document.documentElement.style.maxHeight;
  function i(t) {
    var i = 0;
    return (
      t.each(function () {
        i = Math.max(i, e(this).outerHeight());
      }),
      i
    );
  }
  function s(i, s, n) {
    var h,
      o = 'number' == typeof s ? s : s.height();
    return (
      i
        .removeClass(n.leftEdgeClass)
        .removeClass(n.rightEdgeClass)
        .each(function (i) {
          var a = e(this),
            r = 0,
            g =
              'border-box' === a.css('boxSizing') ||
              'border-box' === a.css('-moz-box-sizing') ||
              'border-box' === a.css('-webkit-box-sizing');
          'number' != typeof s &&
            a.parents().each(function () {
              var t = e(this);
              if (s.is(this)) return !1;
              r += t.outerHeight() - t.height();
            }),
            (h = o - r),
            (h -= g ? 0 : a.outerHeight() - a.height()) > 0 && a.css(n.useMinHeight && t ? 'minHeight' : 'height', h);
        }),
      i.filter(':first').addClass(n.leftEdgeClass),
      i.filter(':last').addClass(n.rightEdgeClass),
      h
    );
  }
})(jQuery);
